module.exports = __webpack_public_path__ + "img/cheese.5f8371ad.png";